import {Component, EventEmitter, Input, Output, SimpleChanges} from '@angular/core';
import {ProgressSpinnerModule} from "primeng/progressspinner";
import {ToastModule} from "primeng/toast";
import {FileUploadModule} from "primeng/fileupload";
import {NgForOf, NgIf} from "@angular/common";
import {TranslatePipe} from "@ngx-translate/core";
import {MessageService, PrimeNGConfig} from "primeng/api";

@Component({
    selector: 'app-upload-document',
    standalone: true,
    imports: [
        ProgressSpinnerModule,
        ToastModule,
        FileUploadModule,
        NgForOf,
        NgIf,
        TranslatePipe
    ],
    templateUrl: './upload-document.component.html',
    styleUrl: './upload-document.component.scss'
})
export class UploadDocumentComponent {

    @Output() emitFiles: EventEmitter<any> = new EventEmitter();

    @Input() isSelectedFileLoading!: boolean;
    @Input() isCloseTriggered!: boolean;

    files = [];

    totalSize: number = 0;

    totalSizePercent: number = 0;

    constructor(private config: PrimeNGConfig, private messageService: MessageService) {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['isCloseTriggered'] && changes['isCloseTriggered'].currentValue && this.files.length > 0) {
            this.emitFiles.emit(this.files);
        }
    }

    choose(event: any, callback: any) {
        callback();
        console.log('choose')
    }

    onRemoveTemplatingFile(event: any, file: any, removeFileCallback: any, index: any) {
        removeFileCallback(event, index);
        console.log('onRemoveTemplatingFile')
    }

    onClearTemplatingUpload(clear: any) {
        clear();
        this.totalSize = 0;
        this.totalSizePercent = 0;
        console.log('onClearTemplatingUpload')
    }

    onTemplatedUpload() {
        this.messageService.add({severity: 'info', summary: 'Success', detail: 'File Uploaded', life: 3000});
        console.log('onTemplatedUpload')
    }

    onSelectedFiles(event: any) {
        this.files = event.currentFiles;
        this.totalSizePercent = this.totalSize / 10;
        console.log('onSelectedFiles')
        this.emitFiles.emit(this.files);
    }

    uploadEvent(callback: any) {
        callback();
    }
}
